<template>
    <div class="px-3 py-2 space-y-2">
        <div class="grid md:grid-cols-2 md:items-center">
            <div>
                <h2 class="text-lg font-semibold">
                    {{ lang('events::events.dashboards.latest_orders') }}
                </h2>
            </div>
            <div class="md:flex md:justify-end">
                <inertia-link
                    :href="route('events/orders.admin.index')"
                    class="inline-flex items-center space-x-2 text-xs font-semibold underline uppercase hover:no-underline"
                >
                    <span>
                        {{ lang('events::orders.actions.manage') }}
                    </span>
                    <icon icon="hero/outline/chevron-right" class="size-4"></icon>
                </inertia-link>
            </div>
        </div>

        <UiCardEmpty v-if="orders && orders.length === 0">
            {{ lang('events::orders.status.no_orders') }}
        </UiCardEmpty>
        <div v-else-if="orders && orders.length > 0" class="space-y-2">
            <EventOrderPreview v-for="order in orders" :key="order.id" :order="order" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { EventOrder } from '@src/Events/Pages/types';
import EventOrderPreview from '@src/Events/Pages/Orders/Preview.vue';

const { props } = usePage();

const page = ref(props.components[2] ?? null);

const orders: Ref<EventOrder[]> = ref(page.value.orders ?? []);
</script>
